import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  init: 'MP',
  name: 'Martín P.',
  city: 'Buenos Aires 🇦🇷',
  quote: '"Compré un sábado. El domingo a la noche tenía el mes de clases listo. Nunca más improviso."',
  color: 'bg-blue-600'
}, {
  init: 'CG',
  name: 'Claudia G.',
  city: 'Córdoba 🇦🇷',
  quote: '"Tres alumnos de inicial que estaban estancados mejoraron su técnica de derecha en el primer mes con el Tomo 3."',
  color: 'bg-purple-600'
}, {
  init: 'FR',
  name: 'Federico R.',
  city: 'Rosario 🇦🇷',
  quote: '"Antes tardaba una hora armando una clase. Ahora son 5 minutos y la estructura es diez veces mejor."',
  color: 'bg-clay-orange'
}, {
  init: 'SV',
  name: 'Sofía V.',
  city: 'Mendoza 🇦🇷',
  quote: '"El Bonus de Físico Express cambió cómo arranco mis clases. Los alumnos rinden más desde el primer game."',
  color: 'bg-pink-600'
}, {
  init: 'DA',
  name: 'Diego A.',
  city: 'Santa Fe 🇦🇷',
  quote: '"El Tomo 12 de Reintegro de Lesiones me salvó con un alumno que volvía de una epicondilitis. Supe exactamente qué hacer."',
  color: 'bg-teal-600'
}, {
  init: 'CR',
  name: 'Carolina R.',
  city: 'Tucumán 🇦🇷',
  quote: '"El Método Anti-Cancelación cambió mi relación con el dinero. Cobro el mes completo sin perseguir a nadie."',
  color: 'bg-indigo-600'
}];
export function Testimonials() {
  return <section className="py-20 bg-offwhite" data-id="element-296">
      <div className="max-w-6xl mx-auto px-4" data-id="element-297">
        <div className="text-center mb-12" data-id="element-298">
          <h3 className="text-3xl md:text-4xl font-display text-charcoal mb-4" data-id="element-299">
            Lo que dicen los profesores
          </h3>
          <div className="flex items-center justify-center gap-2 text-xl font-bold text-charcoal" data-id="element-300">
            4.9/5
            <div className="flex text-ball-yellow" data-id="element-301">
              <StarIcon size={20} fill="currentColor" data-id="element-302" />
              <StarIcon size={20} fill="currentColor" data-id="element-303" />
              <StarIcon size={20} fill="currentColor" data-id="element-304" />
              <StarIcon size={20} fill="currentColor" data-id="element-305" />
              <StarIcon size={20} fill="currentColor" data-id="element-306" />
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-307">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i % 3 * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-308">
              <div className="flex items-center gap-4 mb-4" data-id="element-309">
                <div className={`w-12 h-12 rounded-full ${t.color} text-white flex items-center justify-center font-display text-lg shrink-0`} data-id="element-310">
                  {t.init}
                </div>
                <div data-id="element-311">
                  <div className="font-bold text-charcoal" data-id="element-312">{t.name}</div>
                  <div className="text-xs text-gray-500" data-id="element-313">{t.city}</div>
                </div>
              </div>
              <p className="text-gray-700 italic flex-grow" data-id="element-314">{t.quote}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}